module.exports = __webpack_public_path__ + "static/media/age.5ea4d69d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/age.svg
// module id = 2084
// module chunks = 7